export default class ItineraryButtonsEnum {
    static BUTTON = '[data-wpet-link-route="1"]'
}
